<template>
  <van-popup
    v-model="myVisible"
    :style="{height: '100%'}"
    position="bottom"
    safe-area-inset-bottom
    @close="hidePopup"
  >
    <van-nav-bar title="原料溯源信息" @click-right="hidePopup">
      <template #right>
        <van-icon name="close" size="20" />
      </template>
    </van-nav-bar>
    <div v-if="myVisible" class="popup-content">
      <div class="product-info">
        <unit-title title="基本信息" />
        <div class="wh-grid-between">
          <div>
            <div>名称：{{ traceData.productName }}</div>
            <div v-if="traceCode">
              {{ productType }}标准：{{ traceData.productPlantStandard || '普通' }}农产品
            </div>
            <div>采收时间：{{ formatTime(traceData.productPickTime, 'YYYY-MM-DD') }}</div>
          </div>
          <img :src="traceData.productPic" alt="" @click="ImagePreview([traceData.productPic])">
        </div>
      </div>
      <!--  有溯源信息    -->
      <template v-if="traceCode">
        <farm-work-record-steps :farm-work-records="traceData.farmWorkJSON" class="content-item module" />
      </template>
    </div>
  </van-popup>
</template>

<script>
import { popup } from '@/utils/mixins/popup'
import { traceDataByTraceCode } from '@/utils/mixins/traceDataByTraceCode'
import FarmWorkRecordSteps from '@/views/productManage/TraceSource/components/FarmWorkRecordSteps'
import UnitTitle from '@/views/productManage/TraceSource/components/UnitTitle'
import { ImagePreview } from 'vant'
import { formatTime } from '@/utils/convert/convertTime'
import { PLANT_TYPE_DATE } from '@/constant/common'

export default {
  name: 'ProductInfoPopup',
  components: { UnitTitle, FarmWorkRecordSteps },
  mixins: [popup, traceDataByTraceCode],
  props: {
    traceCode: {
      type: String,
      default: undefined
    },
    traceTempData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      traceData: {
        farmWorkJSON: [],
        land: {},
        userId: undefined
      }
    }
  },
  computed: {
    productType() {
      if (this.traceData.productCropType) {
        return PLANT_TYPE_DATE[this.traceData.productCropType].plantType
      } else {
        return '产品'
      }
    },
    userId() {
      return this.traceData.userId
    },
    landId() {
      if (this.traceData.landId) {
        return this.traceData.landId
      }
      return undefined
    }
  },
  methods: { ImagePreview, formatTime }
}
</script>

<style lang='less' scoped>
.van-nav-bar {
  position: sticky;
  top: 0;
}
.popup-content {
  padding: 12px;
}
.product-info {
  font-size: 14px;
  color: #333;
}
.wh-grid-between {
  display: grid;
  grid-template-columns: 1fr 60px;
  justify-content: space-between;
  align-items: center;
  img {
    width: 100%;
    height: 60px;
    object-fit: cover;
    border-radius: 5px;
  }
}
</style>
